import { useTranslation } from 'react-i18next'
import Typography from '@mui/material/Typography'

// Cor do texto ("dlus" / "by nemala") do logótipo indlus — amostrada
// directamente do PNG. É a mesma que `primary.main` no tema, mas fica fixada
// aqui para a tagline acompanhar o logótipo mesmo que o tema mude.
const LOGO_TEXT_COLOR = '#023160'

/** Tagline dentro do cartão de autenticação. O logótipo, as acções de
 *  contacto e o selector de idioma vivem agora na barra de topo (AuthTopBar). */
export default function BrandHeader() {
  const { t } = useTranslation('auth')

  return (
    <Typography
      component="p"
      sx={{
        mb: 3,
        color: LOGO_TEXT_COLOR,
        fontWeight: 500,
        fontSize: '1.2rem',
        lineHeight: 1.25,
        textTransform: 'uppercase',
        letterSpacing: '0.02em',
      }}
    >
      {t('brand.tagline')}
    </Typography>
  )
}
